export default "/images/af5235a052ca888b8b15b3bb38689fa9.avif";